import * as React from "react";

const LArrow: React.FC<React.SVGProps<SVGElement>> = ({color="#666"}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="24" fill="none">
    <path
      stroke={color}
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m9 18-7-7m7-7-7 7"
    ></path>
  </svg>
);

export default React.memo(LArrow);
